import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div style={{
    minHeight: "60vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: "2rem"
  }}>
    <h1 style={{ fontSize: "3rem", color: "#3b82f6" }}>404</h1>
    <h2>Page Not Found</h2>
    <p style={{ color: "#64748b", marginBottom: "2rem" }}>
      Sorry, the page you are looking for does not exist.
    </p>
    <Link
      to="/"
      style={{
        padding: "0.75rem 1.5rem",
        background: "#3b82f6",
        color: "white",
        borderRadius: "8px",
        textDecoration: "none",
        fontWeight: 500
      }}
    >
      Go Home
    </Link>
  </div>
);

export default NotFound;